import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../lib/translations";

const LanguageContext = createContext(null);
const getPath = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("inspecar_lang") || "id");
  const changeLang = useCallback((l) => {
    localStorage.setItem("inspecar_lang", l);
    setLang(l);
  }, []);
  const t = useCallback((path, vars) => {
    let v = getPath(translations[lang], path);
    if (v === undefined) v = getPath(translations.id, path);
    if (typeof v === "string" && vars) {
      Object.entries(vars).forEach(([k, val]) => { v = v.replace(new RegExp(`{${k}}`, "g"), val); });
    }
    return v;
  }, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
